import React from 'react';
import { Database, FileText, Upload, Search, Trash2 } from 'lucide-react';

const datasets = [
  { id: 1, name: 'koolaber_conversations', type: 'Chat', size: '2.4 GB', rows: '125K', status: 'indexed' },
  { id: 2, name: 'speaker_samples_v3', type: 'Audio', size: '8.7 GB', rows: '2.3K', status: 'indexed' },
  { id: 3, name: 'tts_dataset_clean', type: 'Audio', size: '4.1 GB', rows: '15K', status: 'indexed' },
  { id: 4, name: 'raw_telemetry_logs', type: 'JSON', size: '12 GB', rows: '4.2M', status: 'processing' },
];

function DataSection() {
  return (
    <div className="p-8 space-y-8">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-3xl font-bold text-white">Data</h2>
          <p className="text-slate-400 mt-1">Datasets and storage management</p>
        </div>
        <button className="flex items-center gap-2 px-4 py-2.5 bg-purple-600 hover:bg-purple-500 text-white rounded-xl text-sm font-medium transition-all duration-200 purple-glow">
          <Upload className="w-4 h-4" />
          Upload Dataset
        </button>
      </div>

      <div className="glass-panel divide-y divide-slate-800/50">
        <div className="p-6">
          <h3 className="text-sm font-semibold text-slate-400 uppercase tracking-wider">Datasets</h3>
        </div>
        {datasets.map((ds) => (
          <div key={ds.id} className="p-5 hover:bg-slate-800/30 transition-colors">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-lg bg-amber-600/20 flex items-center justify-center">
                  <Database className="w-5 h-5 text-amber-400" />
                </div>
                <div>
                  <p className="text-white font-semibold">{ds.name}</p>
                  <p className="text-xs text-slate-500">{ds.type} · {ds.rows} rows</p>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <span className="text-xs text-slate-500">{ds.size}</span>
                <span className={`text-xs font-medium px-2.5 py-1 rounded-full ${
                  ds.status === 'indexed' ? 'bg-emerald-600/20 text-emerald-400' : 'bg-amber-600/20 text-amber-400'
                }`}>
                  {ds.status.toUpperCase()}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default DataSection;
